import { Injectable } from '@angular/core';
import { HttpClient ,HttpParams , HttpHeaders} from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GlobalNamespace as _GlobalNS, environment } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { AuctionRequestParams, ReservePriceUpdateRequestParams } from './models/auctionRequest';
import { PaginationParams, LoanItem } from './models/loanItem';

@Injectable({
  providedIn: 'root'
})

export class AuctionService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'eqcpcc': this._global.find((<any>_GlobalNS).paths.eqcpcc)
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getAuctionData(parameters: AuctionRequestParams, paginationParams?:PaginationParams): Observable<any> {
    const api = (<any>_GlobalNS).api.auction.data;
    let params = new HttpParams().set('LoanNumber', parameters.loan)
                                  .set('ReservePriceMin', parameters.minReservePrice)
                                  .set('ReservePriceMax', parameters.maxReservePrice)
                                  .set('ReservePrice', parameters.exactReservePrice)
                                  .set('RecordOffset', paginationParams.offset.toString())
                                  .set('PageRecords', paginationParams.pageSize.toString())
                                  .set('SortDir', paginationParams.sortDir.toString())
                                  .set('SortValue', paginationParams.sortValue.toString())
                                  .delete('LoanNumber', '')
                                  .delete('ReservePriceMin','')
                                  .delete('ReservePriceMax', '')
                                  .delete('ReservePrice','');
    this.httpOptions['params'] = params;
    return this._http.get<any>(`${api}`, this.httpOptions)
      .pipe(
        map((response) => { return this.formatData(response)}),
        catchError(error => {return throwError(error)})
      );
  }

  formatData(response) {
    let formattedData =  response;
    formattedData.data = this.getData(response);
    return formattedData;
  }

  getData(response) : LoanItem []{
    let loanItems = [];
    response.data.map(loanObject =>{
      let tempData= this.setRowData(loanObject);
      loanItems.push(tempData);  
    });
    return loanItems;
  }

  setRowData(element): LoanItem {
    if (!element.LoanDataAvailable) {
      return {
        propertyId:element.PropertyId,
        loan: element.LoanNumber,
        loanDataAvailable: element.LoanDataAvailable
      };
    } else {
      return {
        propertyId:element.PropertyId,
        loan: element.LoanNumber,
        loanDataAvailable: element.LoanDataAvailable,
        auctionCycle: element.LatestListingDetails.listingRound,
        auctionEndingIn: element.AuctionTimeLeft,
        highestBid: element.LatestListingDetails.highestBidAmount,
        totalBids: element.LatestListingDetails.totalBids,
        reservePrice: element.LatestListingDetails.reservePrice,
        edit: false,
        reserveMet: element.ReservePricePercentageMet,
        listStartDate: element.LatestListingDetails.listingStartDate,
        listEndDate: element.LatestListingDetails.listingEndDate,
        bidders: element.LatestListingDetails.numberOfBidders,
        views: element.LatestListingDetails.numberOfViews,
        saves: element.NumberOfSaves,
        initialReservePrice: element.InitialReservePrice,
        perInitialReservePrice: element.InitialReservePrice != (null || 0) ? (element.LatestListingDetails.reservePrice/element.InitialReservePrice)*100 : null,
        perInitialReservePriceOld: element.InitialReservePrice != (null || 0) ? (element.LatestListingDetails.reservePrice/element.InitialReservePrice)*100 : null,
        reservePriceReduction: (element.UpdateStatusValue =='Request Complete' ||
                               (element.UpdateStatusValue == null || element.UpdateStatusValue == '')) ? null : element.ReservePriceReductionPercentageNew,
        reservePriceReductionOld:  element.ReservePriceReductionPercentageNew,
        newReservePrice: (element.UpdateStatusValue =='Request Complete' ||
                         (element.UpdateStatusValue == null || element.UpdateStatusValue == '')) ? null : (element.ReservePriceNew == ("null" || null) ? '' :  element.ReservePriceNew),
        reservePriceOld: element.ReservePriceOld,
        startbid: element.LatestListingDetails.startingBidAmount,
        requestStatus: element.UpdateStatusValue,
        originalReservePrice: element.LatestListingDetails.reservePrice,
        originalperInitialReservePrice: element.InitialReservePrice != (null || 0) ? (element.LatestListingDetails.reservePrice/element.InitialReservePrice)*100 : null,
        originalnewReservePrice : element.ReservePriceNew,
        refreshState: false,
        reservePriceChangedBy: element.UpdateOperatorName,
        reservePriceChangedDate: element.UpdateDate == ("null" || null) ? '' : element.UpdateDate,
        canEditReservePrice :element.CanEditReservePrice == (null || false || 0 ) ? false : true,
        counter: 10,
        counter$: null,
        errorMessage : '' 
      };      
    }
  }

  updateReservePriceAuctionData(postparms: ReservePriceUpdateRequestParams): Observable<any> {
    const api = (<any>_GlobalNS).api.auction.updateReservePrice;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post(`${api}&eqrf=${eqrf}`, postparms)
      .pipe(
        map((response) => response),
        catchError(error => {return throwError(error)})
      );
  }

}
